function setPlanCardsState() {
    const cards = $('.js-plans-cards');
    const isLoggedIn = cards.data('user-logged-in');
    const hasPaid = cards.data('user-has-paid-plan');
    const badge = $('.js-plan-card-badge');
    const elementToHideIfHasPaidPlan = $('.js-hide-if-has-paid-plan');

    if (isLoggedIn) {
        $('.js-show-if-logged-in').addClass('active');
        $('.js-show-if-not-logged-in').removeClass('active');

        if (!hasPaid) {
            badge.addClass('active');
            elementToHideIfHasPaidPlan.addClass('active');
        } else {
            badge.removeClass('active');
            elementToHideIfHasPaidPlan.removeClass('active');
        }
    } else {
        $('.js-show-if-logged-in').removeClass('active');
        $('.js-show-if-not-logged-in').addClass('active');
    }
}

runIfElementExist(setPlanCardsState, '.js-plans-cards');
